module.exports = __webpack_public_path__ + "static/media/peroni-logo.fad569c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/peroni-logo.png
// module id = 744
// module chunks = 0